import { Text, View } from "@/styles/reactnative";
import { CButton } from "@app/components/Common";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DerivativesHeaderSection, DerivativesHeaderWrapper } from "./styles";

import { ThemeContext } from "@/theme/ThemeProvider";
import { COLORS } from "@app/constants";
import { useTradeModalStore } from "@app/hooks/trade/modalStore";
import { IconChevronDown } from "@tabler/icons-react";
import { useTradeSetting } from "../../../../../hooks/trade/tradeSetting";
import useTradeStore from "../../../../../hooks/trade/tradeStore";

const DerivativesHeader = () => {
  const { textw } = React.useContext(ThemeContext).theme.COLORS;
    const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
    const theme = isDarkMode ? 'dark' : 'light';

  const { t } = useTranslation();

  const { data: tradeStore } = useTradeStore();
  const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);
  const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore();

  return (
    <DerivativesHeaderWrapper>
      <DerivativesHeaderSection>
        <View
          style={{
            border: `1px solid #F87943`,
           width: 130,
            backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
            cursor: 'pointer'
          }}

          onClick={() => {
            mutateModalStore({
              ...modalStore,
              crossModal: true,
            });
          }}
        >
          <Text
            size={14}
            style={{ letterSpacing: 1.1, flex: 1, minWidth: 40 }}
          >
            {t(tradeSetting?.cross_iso === "C" ? "cross" : "iso")}
          </Text>
        </View>
        <CButton
          title={`${tradeSetting?.leverage}x`}
          onClick={() => {
            mutateModalStore({
              ...modalStore,
              crossModal: true,
            });
          }}
          iconLeft={false}
          lefticon={<div></div>}
          icon={<IconChevronDown size={18} color={textw} />}
          style={{
            width: 176,
            fontSize: 16,
            justifyContent: "space-between",
            fontWeight: "600",
            color: COLORS.primary,
            letterSpacing: 1.3,
            height: 30,
            borderRadius: 0,
            backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
            cursor: 'pointer'
          }}
        />
      </DerivativesHeaderSection>
    </DerivativesHeaderWrapper>
  );
};

export default DerivativesHeader;
